import { ImageMantine, ImageProps } from '../../DataDisplay';
import _LogoGBSmallBlue from './GBSmallBlue.svg';
import _LogoGBSmallOrange from './GBSmallOrange.svg';
import _LogoGivebacksSupporterApp from './GivebacksSupporterApp.svg';
import _LogoGivebacksTMBlue from './GivebacksTM_Blue.svg';
import _LogoGivebacksTMOrange from './GivebacksTM_Orange.svg';
import LogoGivebacksUncolored from './GivebacksTM_Uncolored';
import _LogoGivebacksTMWhite from './GivebacksTM_White.svg';
import GBOrangeLogoBlueBackground from './brandBackgrounds/GBOrangeLogoBlueBackground.svg';
import BraveLogo from './browserLogos/braveLogo.svg';
import ChromeLogo from './browserLogos/chromeLogo.svg';
import ChromiumLogo from './browserLogos/chromiumLogo.svg';
import EdgeLogo from './browserLogos/edgeLogo.svg';
import SafariLogo from './browserLogos/safariLogo.svg';

const LogoGivebacksBlue = (props: ImageProps) => (
  <ImageMantine src={_LogoGivebacksTMBlue} height={'auto'} {...props} />
);
const LogoGivebacksOrange = (props: ImageProps) => (
  <ImageMantine src={_LogoGivebacksTMOrange} height={'auto'} {...props} />
);
const LogoGivebacksWhite = (props: ImageProps) => (
  <ImageMantine src={_LogoGivebacksTMWhite} height={'auto'} {...props} />
);
const LogoGBSmallBlue = (props: ImageProps) => (
  <ImageMantine src={_LogoGBSmallBlue} height={'auto'} {...props} />
);
const LogoGBSmallOrange = (props: ImageProps) => (
  <ImageMantine src={_LogoGBSmallOrange} height={'auto'} {...props} />
);
const LogoGivebacksSupporterApp = (props: ImageProps) => (
  <ImageMantine src={_LogoGivebacksSupporterApp} height={'auto'} {...props} />
);

export {
  BraveLogo,
  ChromeLogo,
  ChromiumLogo,
  EdgeLogo,
  GBOrangeLogoBlueBackground,
  LogoGBSmallBlue,
  LogoGBSmallOrange,
  LogoGivebacksBlue,
  LogoGivebacksOrange,
  LogoGivebacksSupporterApp,
  _LogoGivebacksTMBlue as LogoGivebacksTMBlueSVG,
  LogoGivebacksUncolored,
  LogoGivebacksWhite,
  SafariLogo,
};
